import React from "react";

const RebateWeb = () => {
  return (
    <div className="desktop_card v-card v-sheet theme--light elevation-0">
      <div className="v-card__title justify-space-between">
        <label
          className="--v-primary-base text-left"
          style={{ color: "black" }}
        >
          Instant Rebate
        </label>
      </div>
      <div className="row px-10 no-gutters justify-end">
        <div className="text-right col col-12">
          <button
            type="button"
            className="history-tab v-btn v-btn--has-bg theme--light v-size--default history-tab-active"
          >
            <span className="v-btn__content">Rebate</span>
          </button>
          <button
            type="button"
            className="history-tab v-btn v-btn--has-bg theme--light v-size--default"
          >
            <span className="v-btn__content">Rebate History</span>
          </button>
        </div>
      </div>
      <div className="rebate-divider" />
      <div className="bank-detail-card v-card v-sheet theme--light elevation-0">
        <div className="row no-gutters">
          <div className="fullHeight col col-12">
            <div className="row rebate-container no-gutters">
              <div className="left-rebate-container">
                <span className="text-pending">Total Pending Claim</span>
                <span className="text-unclaimed">৳ 0.00</span>
              </div>
              <div className="right-rebate-container">
                <button
                  type="button"
                  className="btn-claim v-btn v-btn--has-bg theme--light v-size--default"
                  style={{ height: "40px" }}
                >
                  <span className="v-btn__content">Claim All</span>
                </button>
                <div>
                  <span className="text-date">Last updated </span>
                  <span className="text-date">: -</span>
                </div>
              </div>
            </div>
            <div className="rebate-divider" />
          </div>
          {/**/}
        </div>
        <div className="row">{/**/}</div>
      </div>
    </div>
  );
};

export default RebateWeb;
